module.exports = __webpack_public_path__ + "static/media/figma.e94ca783.svg";